import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpgradeAccountRequest } from "../types/upgradeAccount";

type IUserStateType<T = Record<string, any>> = {
  data?: Partial<UpgradeAccountRequest & T>;
};

const initialState: IUserStateType = {
  data: {},
};

export const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    saveStepperData: <T = Record<string, any>>(
      state,
      action: PayloadAction<IUserStateType<T>["data"]>,
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    completeStepper: (state) => {
      state.data = initialState.data;
    },
  },
});

export const { saveStepperData, completeStepper } = stepperSlice.actions;

export default stepperSlice.reducer;
